import React, { useEffect, useState } from 'react'
import {Link, useParams} from 'react-router-dom'
import './TheatreList.css'
import Navbar from '../Navbar/Navbar';
import axios from 'axios';
import loadgif from '../../Resources/loading2.gif'
import BASE_URL from '../../constant';


function TheatreList() {

    const current = new Date();
    const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const dayArr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const date = `${current.getDate()}`
    const month = `${monthArr[current.getMonth()]}`
    const day =    `${dayArr[current.getDay()]}`;

    const params = useParams();
    const {mId} = params;

    const [theatreListData, setTheatreListData] = useState([]);
    const [movie, setMovie] = useState({});
    const [backImgStyle, setBackImgStyle] = useState({});

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    useEffect(()=>{

        axios.get(`${BASE_URL}/bookmyshow/api/v1/movie/${mId}`)
        .then(res => {
            setMovie(res.data);
            setBackImgStyle({
                backgroundImage : "url(" + res.data.backImage.url + ")"
            });
            setLoading(false);
        })
        .catch(err => console.error(err));

        axios.get(`${BASE_URL}/bookmyshow/api/v1/theatre/movieTime/${mId}`)
        .then(res => {
            console.log(res.data);
            setTheatreListData(res.data);
            setLoading(false);
        })
        .catch(err => {
            console.log(err.message);
            setMessage("Unable to fetch theatres. Please try again later!");
            setLoading(false);
        })

    },[mId]);


    return (
        <>
        <Navbar />
        <div className="theatre-container">
            
            <div className="theatreHeader" style={backImgStyle}>
                <div className="movieName">{movie.name}
                </div>
                <div className="genre">
                    <div className="pills">{movie.genre}</div>
                    {
                        movie.language && movie.language.map((lan,i)=>{
                            return <div key={i} className="pills">{lan}</div>
                        })
                    }
                </div>
            </div>

            <div className="error-message" style={{fontSize: "1.2rem", margin: "20px 0px"}}>{message}</div>

            { (loading) ? <div className='gifContainer'>
                    <img src={loadgif} alt="Loading..." /><div>Loading Theatres in your city ...</div>
                </div>  : 
                <div className="theatrelist-cont">
                    <div className="theatrelist-header">
                        <div className="date-cont">
                            <div className="day">{day}</div>
                            <div className="dateNumber">{date}</div>
                            <div className="day">{month}</div>
                        </div>
                    </div>
                    <div className="theatre-list">
                        {
                            (theatreListData && theatreListData.length>0) ? 
                            (theatreListData.map((obj, i)=>{
                                return <div key={i} className="theatreCard">
                                <div className="theatreName">
                                    <div className="name">
                                        {obj.theatreName}
                                    </div>
                                    <div className="faci">
                                        <i className='fa-solid fa-mobile-screen'></i> M-ticket &nbsp;&nbsp;&nbsp;&nbsp;
                                        <i className='fa-solid fa-pizza-slice'></i> Food & Beverage <br />
                                    </div>
                                </div>
                                <div className="showTiming">    
                                    {
                                        obj.showTiming.map((time, i)=>{
                                            return (
                                                <Link className='alink' key={i} to={
                                                    "/book-tickets?showTimeId=" + time._id 
                                                    + "&theatreId=" + obj.theatreId
                                                    + "&movieId=" + movie._id}>
                                                    <div key={i} className="time">{time.showTime}</div>
                                                </Link>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            })) : "Sorry for your incovienice. Theatres not found."
                        }
                    </div>
                </div>
            }
        </div>
        </>
    )
}

export default TheatreList
